<template>
  <div id="app">
    <router-view />
    <file-oversize-dialog />
    <common-dialog />
  </div>
</template>

<script>
import FileOversizeDialog from '@/components/commonComponents/fileOversizeDialog';
import CommonDialog from '@/components/commonComponents/commonNoticeDialog';

export default {
  name: 'App',
  components: {
    FileOversizeDialog,
    CommonDialog,
  },
};
</script>

<style lang="less" scoped="">
  * {
    box-sizing : border-box;
  }

  #app {
    font-family             : 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing  : antialiased;
    -moz-osx-font-smoothing : grayscale;
    text-align              : center;
    color                   : #2c3e50;
  }

</style>
